import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

import { usePergola } from '../../data-stores/pergola';

import { CanopyColor, CanopyColorHexNumbers } from '../../configurations/colors';

import cappuccino from '../../assets/cappuccino.png';
import doveWhite from '../../assets/dove-white.png';
import sterlingSilver from '../../assets/sterling-silver.png';
import desertSand from '../../assets/desert-sand.png';
import pacificBlue from '../../assets/pacific-blue.png';
import sandStorm from '../../assets/sand-storm.png';

export const CanopyColorRadio = () => {
  const hasCanopy = usePergola(state => state.canopy.hasCanopy);
  const canopyColor = usePergola(state => state.canopy.color);
  const changeCanopyColor = usePergola(state => state.changeCanopyColor);

  const colorOptions = [
    { id: 'c1', color: CanopyColor.CAPPUCCINO, label: 'Cappuccino', image: cappuccino },
    { id: 'c2', color: CanopyColor.DOVE_WHITE, label: 'Dove White', image: doveWhite },
    { id: 'c3', color: CanopyColor.STERLING_SILVER, label: 'Sterling Silver', image: sterlingSilver },
    { id: 'c4', color: CanopyColor.DESERT_SAND, label: 'Desert Sand', image: desertSand },
    { id: 'c5', color: CanopyColor.PACIFIC_BLUE, label: 'Pacific Blue', image: pacificBlue},
    { id: 'c6', color: CanopyColor.SAND_STORM, label: 'Cloud Nine', image: sandStorm}
  ];

  return (
    <RadioGroupPrimitive.Root
      className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto canopy_colors_radio_container my-8 px-4"
      defaultValue={!hasCanopy ? '' : CanopyColor.CAPPUCCINO}
      aria-label="Canopy color selection"
      aria-disabled={!hasCanopy}
      tabIndex={!hasCanopy ? -1 : 0}
      value={canopyColor}
      onValueChange={(value) => changeCanopyColor(value as CanopyColor)}
    >
      {colorOptions.map((option) => (
        <div key={option.id} className="flex flex-col items-center space-y-3">
          <RadioGroupPrimitive.Item
            id={option.id}
            className="relative w-full aspect-[4/3] rounded-lg overflow-hidden border-2 transition-all duration-200 hover:border-gray-400 data-[state=checked]:border-green-600 data-[state=checked]:shadow-lg canopy_colors_radio_group_item"
            value={option.color}
            disabled={!hasCanopy}
          >

              <img
                src={option.image}
                alt={`${option.label} color`}
                className="w-full h-full object-cover canopy_color_rectangle"
              />

            <RadioGroupPrimitive.Indicator className="absolute inset-0 border-2 border-green-600 rounded-lg canopy_color_indicator" />
          </RadioGroupPrimitive.Item>
          <label
            htmlFor={option.id}
            className={`text-sm font-medium text-center cursor-pointer ${
              canopyColor === option.color 
                ? 'text-green-600 canopy_design_color_selected_label' 
                : 'text-gray-700 canopy_design_color_label'
            }`}
          >
            {option.label}
          </label>
        </div>
      ))}
    </RadioGroupPrimitive.Root>
  );
};

export default CanopyColorRadio;
